// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  ApprovalDecision,
  ApproveModuleVersionBody,
  GenericApiResponseModuleLecturerResponse,
  GenericApiResponseModuleUpgradePreviewResponse,
  GetModuleUpgradeOfferPreviewParams,
  HTTPValidationError,
  RequestModuleVersionApprovalBody,
} from '../../models';

/**
 * Preview grouped student upgrade dialogs for a draft offer target.
 * @summary Get Module Upgrade Offer Preview
 */
export const getModuleUpgradeOfferPreview = (
  moduleId: string,
  version: string,
  params?: GetModuleUpgradeOfferPreviewParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleUpgradePreviewResponse>> => {
  return axios.get(`/modules/${moduleId}/versions/${version}/upgrade-offer-preview`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetModuleUpgradeOfferPreviewQueryKey = (
  moduleId: string,
  version: string,
  params?: GetModuleUpgradeOfferPreviewParams,
) => {
  return [`/modules/${moduleId}/versions/${version}/upgrade-offer-preview`, ...(params ? [params] : [])] as const;
};

export const getGetModuleUpgradeOfferPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  params?: GetModuleUpgradeOfferPreviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetModuleUpgradeOfferPreviewQueryKey(moduleId, version, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>> = ({ signal }) =>
    getModuleUpgradeOfferPreview(moduleId, version, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(moduleId && version), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetModuleUpgradeOfferPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>
>;
export type GetModuleUpgradeOfferPreviewQueryError = AxiosError<HTTPValidationError>;

export function useGetModuleUpgradeOfferPreview<
  TData = Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  params: undefined | GetModuleUpgradeOfferPreviewParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleUpgradeOfferPreview<
  TData = Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  params?: GetModuleUpgradeOfferPreviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetModuleUpgradeOfferPreview<
  TData = Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  params?: GetModuleUpgradeOfferPreviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Module Upgrade Offer Preview
 */

export function useGetModuleUpgradeOfferPreview<
  TData = Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>,
  TError = AxiosError<HTTPValidationError>,
>(
  moduleId: string,
  version: string,
  params?: GetModuleUpgradeOfferPreviewParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleUpgradeOfferPreview>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetModuleUpgradeOfferPreviewQueryOptions(moduleId, version, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Request approval for a module version

This transitions a module from DRAFT to PENDING_APPROVAL state

Approval types:
- PUBLISH_INITIAL: For publishing the very first version of a module
- REPLACE_VERSION: Replace existing version(s) for all students
- NEW_VERSION: Create a new version alongside existing ones
 * @summary Request Module Version Approval
 */
export const requestModuleVersionApproval = (
  moduleId: string,
  version: string,
  requestModuleVersionApprovalBody: RequestModuleVersionApprovalBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.post(
    `/modules/${moduleId}/versions/${version}/request-approval`,
    requestModuleVersionApprovalBody,
    options,
  );
};

export const getRequestModuleVersionApprovalMutationOptions = <
  TData = Awaited<ReturnType<typeof requestModuleVersionApproval>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: RequestModuleVersionApprovalBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['requestModuleVersionApproval'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestModuleVersionApproval>>,
    { moduleId: string; version: string; data: RequestModuleVersionApprovalBody }
  > = (props) => {
    const { moduleId, version, data } = props ?? {};

    return requestModuleVersionApproval(moduleId, version, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: RequestModuleVersionApprovalBody },
    TContext
  >;
};

export type RequestModuleVersionApprovalMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestModuleVersionApproval>>
>;
export type RequestModuleVersionApprovalMutationBody = RequestModuleVersionApprovalBody;
export type RequestModuleVersionApprovalMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Request Module Version Approval
 */
export const useRequestModuleVersionApproval = <
  TData = Awaited<ReturnType<typeof requestModuleVersionApproval>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: RequestModuleVersionApprovalBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; data: RequestModuleVersionApprovalBody },
  TContext
> => {
  const mutationOptions = getRequestModuleVersionApprovalMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Approve a module version

This transitions a module from PENDING_APPROVAL to PUBLISHED state
 * @summary Approve Module Version
 */
export const approveModuleVersion = (
  moduleId: string,
  version: string,
  approveModuleVersionBody: ApproveModuleVersionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.post(`/modules/${moduleId}/versions/${version}/approve`, approveModuleVersionBody, options);
};

export const getApproveModuleVersionMutationOptions = <
  TData = Awaited<ReturnType<typeof approveModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: ApproveModuleVersionBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['approveModuleVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveModuleVersion>>,
    { moduleId: string; version: string; data: ApproveModuleVersionBody }
  > = (props) => {
    const { moduleId, version, data } = props ?? {};

    return approveModuleVersion(moduleId, version, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: ApproveModuleVersionBody },
    TContext
  >;
};

export type ApproveModuleVersionMutationResult = NonNullable<Awaited<ReturnType<typeof approveModuleVersion>>>;
export type ApproveModuleVersionMutationBody = ApproveModuleVersionBody;
export type ApproveModuleVersionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Approve Module Version
 */
export const useApproveModuleVersion = <
  TData = Awaited<ReturnType<typeof approveModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: ApproveModuleVersionBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; version: string; data: ApproveModuleVersionBody },
  TContext
> => {
  const mutationOptions = getApproveModuleVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Send a module version back for revision

This transitions a module from PENDING_APPROVAL back to DRAFT state with feedback
 * @summary Reject Module Version
 */
export const rejectModuleVersion = (
  moduleId: string,
  version: string,
  approvalDecision: ApprovalDecision,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.post(`/modules/${moduleId}/versions/${version}/reject`, approvalDecision, options);
};

export const getRejectModuleVersionMutationOptions = <
  TData = Awaited<ReturnType<typeof rejectModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string; data: ApprovalDecision }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['rejectModuleVersion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectModuleVersion>>,
    { moduleId: string; version: string; data: ApprovalDecision }
  > = (props) => {
    const { moduleId, version, data } = props ?? {};

    return rejectModuleVersion(moduleId, version, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string; data: ApprovalDecision },
    TContext
  >;
};

export type RejectModuleVersionMutationResult = NonNullable<Awaited<ReturnType<typeof rejectModuleVersion>>>;
export type RejectModuleVersionMutationBody = ApprovalDecision;
export type RejectModuleVersionMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Reject Module Version
 */
export const useRejectModuleVersion = <
  TData = Awaited<ReturnType<typeof rejectModuleVersion>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string; data: ApprovalDecision }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string; version: string; data: ApprovalDecision }, TContext> => {
  const mutationOptions = getRejectModuleVersionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Remove the upgrade offer from a published module version (admin only).
 * @summary Remove Module Upgrade Offer
 */
export const removeModuleUpgradeOffer = (
  moduleId: string,
  version: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleLecturerResponse>> => {
  return axios.delete(`/modules/${moduleId}/versions/${version}/upgrade-offer`, options);
};

export const getRemoveModuleUpgradeOfferMutationOptions = <
  TData = Awaited<ReturnType<typeof removeModuleUpgradeOffer>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['removeModuleUpgradeOffer'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeModuleUpgradeOffer>>,
    { moduleId: string; version: string }
  > = (props) => {
    const { moduleId, version } = props ?? {};

    return removeModuleUpgradeOffer(moduleId, version, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; version: string },
    TContext
  >;
};

export type RemoveModuleUpgradeOfferMutationResult = NonNullable<Awaited<ReturnType<typeof removeModuleUpgradeOffer>>>;

export type RemoveModuleUpgradeOfferMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Remove Module Upgrade Offer
 */
export const useRemoveModuleUpgradeOffer = <
  TData = Awaited<ReturnType<typeof removeModuleUpgradeOffer>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { moduleId: string; version: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { moduleId: string; version: string }, TContext> => {
  const mutationOptions = getRemoveModuleUpgradeOfferMutationOptions(options);

  return useMutation(mutationOptions);
};
